@if(preMode){
<p-button
  fluid="true"
  size="small"
  i18n-label="@@open-markdown"
  label="Öffne Markdown"
  (onClick)="this.toggleView()"
></p-button>
<pre>{{this.contents}}</pre>
}@else {
<p-button
  fluid="true"
  size="small"
  i18n-label="@@open-raw"
  label="Öffne Rohtext"
  (onClick)="this.toggleView()"
></p-button>
<markdown [data]="this.contents"></markdown>
}
